<template>
  <div class="tracking-network-view">
    <router-view v-slot="slotProps">
      <component :is="slotProps?.Component" @saved="onCredentialsSaved" />
    </router-view>

    <layout-logged-frame
      :back-url="backUrl"
      :title="activeNetwork.name"
      >
      <template #header-actions>
        <v-btn
          color="primary"
          @click="openNewCredentialsModal"
        >
          <v-icon>add</v-icon>
          {{ $t('new_credentials') }}
        </v-btn>
      </template>

      <template #content>
        <v-card
          class="elevation-0"
          :loading="isLoading"
        >
          <panels-tracking-network :network="activeNetwork" />
        </v-card>

        <table-tracking-credentials ref="credentialsTable" :network="activeNetwork" />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLoading: false,
      };
    },
    computed: {
      // A plain path string, because layout-logged-frame's back-url prop only
      // accepts one — router.resolve builds it while keeping the list's query.
      backUrl() {
        return this.$router.resolve({ name: 'tracking-networks', query: this.$route.query }).href;
      },
      activeNetwork() {
        return this.$store.getters['tracking/activeTrafficNetwork'] || {};
      },
    },
    created() {
      this.getNetwork(this.$route.params.id);
    },
    methods: {
      onCredentialsSaved() {
        this.$refs.credentialsTable.getCredentials();
      },
      getNetwork(id) {
        this.isLoading = true;
        this.$store.dispatch('tracking/getTrafficNetwork', id)
          .catch((err) => err)
          .finally(() => {
            this.isLoading = false;
          });
      },
      openNewCredentialsModal() {
        this.$router.push({ name: 'tracking-networks-new-credentials', query: this.$route.query });
      },
    },
  };
</script>
